import { render, staticRenderFns } from "./TopicResearchPhaseStat.vue?vue&type=template&id=237fdc0b&scoped=true&"
import script from "./TopicResearchPhaseStat.vue?vue&type=script&lang=js&"
export * from "./TopicResearchPhaseStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237fdc0b",
  null
  
)

export default component.exports